import { WARM_DASHBOARD_API_BASE } from "./apiEndpoints";

export default function LoadTestimonialsService() {
  const options = {
    method: "GET",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  };

  return fetch(
    `${WARM_DASHBOARD_API_BASE}/loadTestimonialsService`,
    options
  );
}
